import { LocalDateTime } from "@js-joda/core";
import React from "react";
import { globalize } from "../../../translate";
import { AppCard, AppCardContent } from "../../Generic/AppCard";
import Flex from "../../Generic/Flex";
import PatientAvatar from "../../PatientAvatar/PatientAvatar";

interface TimesheetVisitCardProps {
  patientName: string;
  visitStartTime: LocalDateTime;
  visitEndTime: LocalDateTime;
}

function TimesheetVisitCard(props: TimesheetVisitCardProps) {
  const initials = props.patientName
    .split(" ")
    .map((x) => x[0])
    .join("")
    .toUpperCase()
    .substr(0, 2);

  const startTime = globalize().formatLocalDateTime(props.visitStartTime, { datetime: "short" });
  const endTime = globalize().formatLocalDateTime(props.visitEndTime, { time: "short" });

  return (
    <AppCard className="TimesheetVisitCard">
      <AppCardContent>
        <Flex xGap={16}>
          <PatientAvatar initials={initials} />
          <div className="VisitCard-info">
            <h5>{props.patientName}</h5>
            <p>
              {startTime} - {endTime}
            </p>
          </div>
        </Flex>
      </AppCardContent>
    </AppCard>
  );
}

export default TimesheetVisitCard;
